import { Component, OnInit, ElementRef, HostListener } from '@angular/core';
import {Cedant, Contract, Program} from '../../shared/shared.types';
import {ContractSelectorStateService} from '../../shared/contract-selector-state-service/contract-selector-state.service';
import {MatDialog, MatDialogConfig} from '@angular/material';
import {Router} from '@angular/router';
import {DialogService} from '../../shared/dialog-service/dialog.service';
import {ContractSelectorService} from '../../shared/contract-selector-service/contract-selector.service';
import {CreateProgramComponent} from '../../shared/create-program/create-program.component';

@Component({
  selector: 'app-cedant-program-view',
  templateUrl: './cedant-program-view.component.html',
  styleUrls: ['./cedant-program-view.component.scss']
})
export class CedantProgramViewComponent implements OnInit {

  constructor(
    private elementRef: ElementRef,
    private dialog:                   MatDialog,
    private router:                   Router,
    private ourDialogSrv:             DialogService,
    private provider:                 ContractSelectorService,
    private contractSelectorState: ContractSelectorStateService) {
  }

  selectedCedant:   Cedant     = null;
  selectedProgram:  Program    = null;
  selectedContract: Contract   = null;

  isProgramsSelectionOpen: boolean;


  @HostListener('window:resize')
  onResize() {
    this.closeProgramsDropdown();
  }

  ngOnInit() {

    this.contractSelectorState
      .cedant$
      .subscribe( cedant => {
        this.selectedCedant = cedant;
      });

    this.contractSelectorState
      .cedant$.subscribe( c => {
      this.selectedCedant = c;
      if (c) {
        this.selectedProgram = c.programs[0];
      }
    });
  }

  pickProgram(program: Program) {
    if (this.selectedProgram) {
      this.selectedProgram.isSelected = false;
    }
    this.selectedProgram = program;
    this.selectedProgram.isSelected = true;
    this.contractSelectorState.currentProgram = program;
    this.contractSelectorState.setProgramActive();
    this.router.navigate(['cedant', this.selectedCedant.id || 0, 'program', program.id || 0]);
  }

  pickContract(contract: Contract) {
    if (this.selectedContract) {
      this.selectedContract.isSelected = false;
    }
    this.selectedContract = contract;
    this.selectedContract.isSelected = true;
    this.contractSelectorState.currentContract = contract;
    this.contractSelectorState.setContractActive();
    this.router.navigate(['cedant', this.selectedCedant.id || 0, 'program', this.selectedProgram.id || 0, 'contract', contract.id || 0]);
  }

  onAddContract() {
    this.ourDialogSrv.openCreateContract().afterClosed().subscribe(result => {
      if (result.isOk) {
        if (this.selectedProgram.contracts[0]) {
          if (this.selectedContract) {
            this.selectedContract.isSelected = false;
          }
          this.selectedContract = this.selectedProgram.contracts[0];
          this.selectedContract.isSelected = true;
          this.contractSelectorState.currentContract = this.selectedProgram.contracts[0];
          this.contractSelectorState.setContractActive();
          this.router.navigate(['cedant', this.selectedCedant.id || 0, 'program', this.selectedProgram.id || 0, 'contract',  this.selectedContract.id]);
        } else {
          this.router.navigate(['/cedant/0/program/0/contract/0/dashboard']);
        }
      }
    });
  }

  onCreateProgram() {
    const config = new MatDialogConfig();
    config.data = {title: 'Program'};
    config.minHeight = '400px';
    config.width = '640px';
    config.panelClass = 'dialog-container-wizard';

    const dialogRef = this.dialog.open(CreateProgramComponent, config);

    dialogRef.afterClosed().subscribe(result => {
      if (result.isOk) {
        //this.programs.push(new Program(0, 'Program 1'));
      }
    });
  }

  togglePrograms() {
    this.isProgramsSelectionOpen = !this.isProgramsSelectionOpen;
  }


  private closeProgramsDropdown() {
    const documentWidth = this.elementRef.nativeElement.ownerDocument.documentElement.clientWidth;
    if (documentWidth > 768) {
      this.isProgramsSelectionOpen = false;
    }
  }
}
